module.exports = __webpack_public_path__ + "img/avatar.8199f1aa.svg";